export default "__VITE_ASSET__BdTzTwFg__"